import React, { useLayoutEffect, useRef, useState } from 'react';

const MSG = 'Data inválida (ex.: 31/09 não existe). O filtro continua usando a data anterior até ser corrigida.';

/**
 * Campo de data para FILTROS de período. Data inexistente digitada (31/09,
 * 30/02...) faz o <input type="date"> devolver value='' — que nos filtros
 * vira "sem limite" e traz registros fora do período. Aqui esse caso não
 * chega ao onChange: o campo fica vermelho e o filtro mantém o último valor
 * válido. Apagar a data de propósito (value='' sem badInput) passa normal.
 *
 * Não-controlado de propósito: um input controlado pelo React voltaria o
 * texto para o valor anterior a cada dígito inválido, impedindo digitar
 * o dia antes do mês (ex.: 30/09 → 31/10).
 */
export default function InputDataFiltro({ value, onChange, style, title, ...rest }) {
  const ref = useRef(null);
  const [invalida, setInvalida] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (el.value !== (value ?? '') || el.validity.badInput) el.value = value ?? '';
    if (!el.validity.badInput) { el.setCustomValidity(''); setInvalida(false); }
  }, [value]);

  const handleChange = (e) => {
    const el = e.target;
    if (el.value === '' && el.validity.badInput) {
      el.setCustomValidity(MSG);
      setInvalida(true);
      return;
    }
    el.setCustomValidity('');
    setInvalida(false);
    onChange?.(e);
  };

  return (
    <>
      <input
        {...rest}
        ref={ref}
        type="date"
        defaultValue={value ?? ''}
        onChange={handleChange}
        title={invalida ? MSG : title}
        style={invalida ? { ...style, borderColor: '#c62828', background: '#ffebee' } : style}
      />
      {invalida && (
        <span title={MSG} style={{ color: '#c62828', fontWeight: 700, fontSize: 12, whiteSpace: 'nowrap', cursor: 'help' }}>
          ⚠ Data inválida
        </span>
      )}
    </>
  );
}
